import React, { useEffect, useMemo, useState } from 'react';
import { gatewayApi } from '../services/gateway';

export default function Queue() {
  const [jobs,setJobs]=useState([]);
  const [loading,setLoading]=useState(true);
  const [error,setError]=useState('');
  const [filter,setFilter]=useState('all');
  const [search,setSearch]=useState('');
  const [busy,setBusy]=useState('');
  const load=async()=>{
    setLoading(true);setError('');
    try{const r=await gatewayApi.listQueue();setJobs(r.data||[]);}
    catch(e){setError(e.message||'Unable to retrieve email queue.');}
    finally{setLoading(false);}
  };
  useEffect(()=>{load();},[]);
  const counts=useMemo(()=>{
    const result={all:jobs.length,queued:0,processing:0,sent:0,failed:0,cancelled:0};
    jobs.forEach(j=>{if(Object.hasOwn(result,j.status))result[j.status]++;});
    return result;
  },[jobs]);
  const shown=useMemo(()=>jobs.filter(j=>{
    if(filter!=='all'&&j.status!==filter)return false;
    const term=search.toLowerCase().trim();
    return !term||[j.to_email,j.subject,j.app_id,j.id].some(v=>String(v||'').toLowerCase().includes(term));
  }),[jobs,filter,search]);
  const act=async(job,kind)=>{
    const verb=kind==='retry'?'retry':'cancel';
    if(!window.confirm('Confirm '+verb+' for '+job.to_email+'?'))return;
    setBusy(job.id);setError('');
    try{
      if(kind==='retry')await gatewayApi.retryQueue(job.id);
      else await gatewayApi.cancelQueue(job.id);
      await load();
    }catch(e){setError(e.message||'Could not update message');}
    finally{setBusy('');}
  };
  const shownDate=v=>{if(!v)return '—';const d=new Date(v);return Number.isNaN(d.valueOf())?v:d.toLocaleString('en-AU');};
  return <div className="space-y-5 pb-12">
    <header className="flex flex-wrap items-start justify-between gap-3">
      <div><h2 className="text-2xl font-bold text-slate-900">Delivery queue</h2>
        <p className="text-sm text-slate-500">Persistent PocketBase jobs. Provider acceptance does not guarantee inbox delivery.</p></div>
      <button onClick={load} disabled={loading} className="rounded-xl border bg-white px-4 py-2 text-sm disabled:opacity-40">Refresh</button>
    </header>
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-2">
      {Object.entries(counts).map(([name,value])=><button key={name} onClick={()=>setFilter(name)}
        className={'rounded-xl border p-3 text-left '+(filter===name?'bg-blue-50 border-blue-300':'bg-white')}>
        <div className="text-xl font-bold">{value}</div><div className="text-xs capitalize text-slate-500">{name}</div></button>)}
    </div>
    {error&&<p role="alert" className="border border-red-200 bg-red-50 text-red-700 rounded-xl p-3">{error}</p>}
    <input className="w-full rounded-xl border p-3 bg-white" aria-label="Search email queue" placeholder="Search recipient, subject or request ID"
      value={search} onChange={e=>setSearch(e.target.value)}/>
    <div className="rounded-2xl border bg-white overflow-x-auto">
      <table className="min-w-full text-sm text-left">
        <thead className="bg-slate-50"><tr><th className="p-3">Recipient / subject</th><th className="p-3">Status</th><th className="p-3">Attempts</th><th className="p-3">Scheduled</th><th className="p-3">Failure reason</th><th className="p-3">Action</th></tr></thead>
        <tbody>{shown.map(job=><tr key={job.id} className="border-t align-top">
          <td className="p-3"><div className="font-semibold">{job.to_email}</div><div className="text-slate-500 max-w-[260px] truncate">{job.subject}</div><div className="font-mono text-xs text-slate-400">{job.id}</div></td>
          <td className="p-3 capitalize">{job.status}</td><td className="p-3">{job.attempt_count}</td>
          <td className="p-3 whitespace-nowrap">{shownDate(job.scheduled_at)}</td>
          <td className="p-3 max-w-[250px] text-xs text-red-700 break-words">{job.error_message||'—'}</td>
          <td className="p-3"><div className="flex flex-col gap-2">
            {job.status==='failed'&&<button disabled={!!busy} onClick={()=>act(job,'retry')} className="text-blue-700 disabled:opacity-40 text-left">Retry</button>}
            {job.status==='queued'&&<button disabled={!!busy} onClick={()=>act(job,'cancel')} className="text-red-700 disabled:opacity-40 text-left">Cancel</button>}
          </div></td>
        </tr>)}</tbody>
      </table>
      {!loading&&!shown.length&&<p className="p-5 text-slate-500">No messages match this filter.</p>}
      {loading&&<p className="p-5 text-slate-500">Loading queue…</p>}
    </div>
    <p className="text-xs text-slate-500">Shows the newest 200 jobs. Schedule processing and delivery webhooks must be configured separately on PocketHost and Emailit.</p>
  </div>;
}